const purpleLabHost = 'https://api-dev.purplelab.com/';

export const environment = {
  production: false,
  development: true,
  apiUrl: 'https://api-dev.purplelab.com/datadictionary/api',
  ssoUrl: 'https://api-dev.healthnexus.io/healthnexussso/',
  portalUrl: 'https://dev-portal.purplelab.com/',
  purpleLabHost,
  allowMockToggle: false,
  isLocal: false,
  sentry: {
    dsn: 'https://9d60264547efc5450d27d7a2bdccd5a7@o465365.ingest.us.sentry.io/4512289465761792',
    enabled: true,
    environment: 'dev',
  },
  mixpanel: {
    // One shared Mixpanel project token (public by design). Empty token = Mixpanel is a silent no-op.
    token: '171e02a815cdc4b3966ee1d82b20d7d9',
    // Session replay only on the dictionary detail and master tables screens.
    enableReplay: true,
    // Percentage of page sessions recorded (sampled once per page load).
    replayPercent: 100,
    // Shared Purplelab GDPR service: GET returns { region, opt_out }.
    optOutUrl: `${purpleLabHost}gdpr/opt_out`,
  },
};
